import { Component } from "@angular/core";

@Component({
  selector: "ds-dropdown-trigger",
  templateUrl: "./ds-dropdown-trigger.component.html",
  styleUrls: ["./ds-dropdown-trigger.component.scss"],
})
export class DsDropdownTriggerComponent {
  constructor() {}
}
